<template>
  <div style="display:none" />
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { toast } from 'vue-sonner'
import { useI18n } from '#i18n'
import { useNotificationToast } from '~/composables/notificationToast/useNotificationToast'

const { t } = useI18n()
const { pendingNotifications } = useNotificationToast()

watch(
  pendingNotifications,
  (notifications) => {
    if (notifications.length === 0) return

    const toShow = [...notifications]
    pendingNotifications.value = []

    toShow.forEach((n, index) => {
      setTimeout(() => {
        toast(t(`notifications.${n.type}.title`, n.parameters), {
          description: t(`notifications.${n.type}.body`, n.parameters),
          duration: 5000,
          closeButton: true
        })
      }, index * 100)
    })
  },
  { deep: true }
)
</script>
